import { h, Component } from 'preact';
import PartnershipListing from '../../components/common/Partnerships';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { partnershipData } from '../../redux/actions/partnerships.js';


class Partnership extends Component{
	componentDidMount() {
		const path = this.props.match.params.slug;
		this.props.partnershipData(path);
	}
	render(props){
		return(<PartnershipListing data={this.props.data} />)
	}
}
const mapStateToProps = state => ({
    data: state.partnerships,
});

const mapDispatchToProps = dispatch => ({
    partnershipData: (data) => dispatch(partnershipData(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Partnership));


// WEBPACK FOOTER //
// ../q-cars/src/containers/Partnership/partnershiparea.js